module.exports = __webpack_public_path__ + "img/20250220-01-01.7b2dbb2d.png";